import { render, staticRenderFns } from "./TagsAccordions.vue?vue&type=template&id=11c72561&scoped=true&"
import script from "./TagsAccordions.vue?vue&type=script&lang=js&"
export * from "./TagsAccordions.vue?vue&type=script&lang=js&"
import style0 from "./TagsAccordions.vue?vue&type=style&index=0&id=11c72561&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c72561",
  null
  
)

export default component.exports